import Axios from "axios";
import qs from "qs";

import { LabelList } from "../../features/subscriptions/modules/label/models/LabelList";
import { Label } from "../../features/subscriptions/modules/label/models/Label";

export class Labels {
  constructor(apiUrl, headers) {
    this.apiUrl = `${apiUrl}/package-labels`;
    this.headers = headers;
  }

  async list(params) {
    const queryString = qs.stringify(params, {
      addQueryPrefix: true,
    });

    const url = `${this.apiUrl}${queryString}`;
    const response = await Axios.get(url, { headers: this.headers });

    // Convert API response to LabelList format
    const labelList = LabelList.createFromResponse(response.data);

    return new LabelList(
      labelList.items,
      labelList.total,
      labelList.page,
      labelList.limit
    );
  }

  async getById(id) {
    const url = `${this.apiUrl}/${id}`;
    const response = await Axios.get(url, { headers: this.headers });

    return Label.createFromResponse(response.data.result);
  }

  async delete(id) {
    const url = `${this.apiUrl}/${id}`;
    const response = await Axios.delete(url, { headers: this.headers });

    return response.data;
  }

  async create(data) {
    const response = await Axios.post(this.apiUrl, data, {
      headers: this.headers,
    });

    return response.data;
  }

  async update(id, data) {
    const url = `${this.apiUrl}/${id}`;
    const response = await Axios.put(url, data, { headers: this.headers });

    return response.data;
  }

  async listAll() {
    const url = `${this.apiUrl}/all`;
    const response = await Axios.get(url, { headers: this.headers });

    const labels = response.data.result || [];

    return labels.map((label) => Label.createFromResponse(label, true));
  }
}
